import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import PageErrorRoutes from '@/router/routes/page-error'
import auth from '@/resources/axios/providers/auth'
import store from '@/store'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home/Home.vue')
  },
  PageErrorRoutes,
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/PageError/PageError.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from) {
    if (to.path === from.path) {
      return null
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  if (!to.name) {
    window.location.href = process.env.VUE_APP_ADWORK
    return
  }
  store.dispatch('app/setLoading', true)
  // stimulate cookies
  const { token } = await auth.getCsrfToken()
  store.dispatch('auth/setCsrf', token)
  store.dispatch('app/setLoading', false)
  next()
})
export default router
